<template>
  <div class="">
    <div class="mt-2 width-of-input" v-if="product.variation == 0 || mode=='order'">
      <p class="text-right m-0 p-0">{{ propModeTranslator[mode] }}</p>
      <div class="input-group" dir="ltr">
        <div class="input-group-prepend">
          <button @click="updateQuantityPriceOffer()" class="btn btn-sm btn-secondary"
                  type="button">
            <b-icon icon="check-circle"></b-icon>
          </button>
        </div>
        <input dir="rtl" @keypress.enter="updateQuantityPriceOffer()" v-model="product[mode]" type="number"
               class="form-control text-left">


      </div>
      <span class="d-block" v-if="product[mode]">{{formatNumber(product[mode])}}</span>
    </div>
    <div class="" v-if="mode=='price' && product.variation == 1">
      {{ getProductPriceRange(product) }}
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {getProductPriceRange} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'

export default {
  name: "TablePriceController",
  props: ['product', 'mode'], // three mode: quantity, price and offer
  data() {
    return {
      tempValue: '',
      propModeTranslator: {
        price: 'قیمت',
        quantity: 'تعداد',
        offer: 'تخفیف',
        order: 'ترتیب',
      }
    }
  },
  methods: {
    formatNumber,
    getProductPriceRange,
    updateQuantityPriceOffer() {

      let form = {
        product_id: this.product.id,
      }

      if (this.product.quantity !== null && this.product.quantity.toString() !== '' && this.product.quantity.toString().trim().length !== 0) {
        form['quantity'] = this.product.quantity;
      }

      if (this.product.offer !== null && this.product.offer.toString() !== '' && this.product.offer.toString().trim().length !== 0) {
        form['offer'] = this.product.offer;
      }

      if (this.product.price !== null && this.product.price.toString() !== '' && this.product.price.toString().trim().length !== 0) {
        form['price'] = this.product.price;
      }

      if (this.product.order !== null && this.product.order.toString() !== '' && this.product.order.toString().trim().length !== 0) {
        form['order'] = this.product.order;
      }

      this.$store.dispatch('Product/updateQuantityPriceOffer', form)
    }
  },

}
</script>

<style scoped>
.width-of-input {
  min-width: 150px
}
</style>